// The page: the start screen, or the meeting the user is in, and what shows over them (an image whole, a
// dialog). main.tsx draws it again whenever the state changes (store.ts).
import { state } from "../store.ts";
import { MeetingView } from "./Meeting.tsx";
import { Overlays } from "./Overlays.tsx";
import { Start } from "./Start.tsx";

export function App() {
  return (
    <>
      {state.meeting === null ? <Start /> : <MeetingView />}
      <Overlays />
    </>
  );
}

/** What happens, or what went wrong. */
export function Status() {
  return <div class={state.error ? "status error" : "status"}>{state.status}</div>;
}
